import React from "react";
import fundraiserIcon from "../../../Assets/Icons/FundraiserIcon.svg";
import merchantIcon from "../../../Assets/Icons/merchantIcon.svg";
import memberIcon from "../../../Assets/Icons/userIcon.svg";

const ACCOUNT_ROLE_BADGES = {
  user: {
    label: "Member",
    className: "bg-[#EAF2FF] text-[#00ADEF]",
    icon: memberIcon,
  },
  member: {
    label: "Member",
    className: "bg-[#EAF2FF] text-[#00ADEF]",
    icon: memberIcon,
  },
  merchant: {
    label: "Merchant",
    className: "bg-[#FFF5E6] text-[#C27A00]",
    icon: merchantIcon,
    iconFilter:
      "brightness(0) saturate(100%) invert(49%) sepia(77%) saturate(1260%) hue-rotate(4deg) brightness(91%) contrast(101%)",
  },
  fundraiser: {
    label: "Fundraiser",
    className: "bg-[#E9EAEC] text-[#252A31]",
    icon: fundraiserIcon,
    iconFilter:
      "brightness(0) saturate(100%) invert(15%) sepia(8%) saturate(915%) hue-rotate(178deg) brightness(94%) contrast(91%)",
  },
  admin: { label: "Admin", className: "bg-[#E9EAEC] text-[#252A31]" },
};

const MultipleAccountsModal = ({
  email,
  accountCount,
  roles = [],
  onCancel,
  onContinue,
  loading = false,
}) => {
  const roleBadges = [
    ...new Map(
      roles.map((role) => {
        const badge = ACCOUNT_ROLE_BADGES[role] || {
          label: role,
          className: "bg-[#E9EAEC] text-[#252A31]",
        };
        return [badge.label, badge];
      }),
    ).values(),
  ];

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center overflow-y-auto bg-[#15171B]/50 px-4 py-6">
      <div
        className="relative w-full max-w-[440px] rounded-[20px] bg-white px-6 py-6 font-poppins shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="reset-accounts-title"
      >
        <button
          type="button"
          aria-label="Close password reset confirmation"
          onClick={onCancel}
          disabled={loading}
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center text-[24px] leading-none text-[#687080] disabled:opacity-50"
        >
          ×
        </button>
        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-[#EAF5FF] text-[#00ADEF]">
          <svg
            viewBox="0 0 24 24"
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            aria-hidden="true"
          >
            <circle cx="8" cy="15" r="4" />
            <path d="m10.8 12.2 8.7-8.7m-3.2 3.2 2.2 2.2m-5.1.9 2.2 2.2" />
          </svg>
        </div>
        <h2
          id="reset-accounts-title"
          className="pr-8 text-[18px] font-[600] leading-tight text-[#20232A]"
        >
          This password is used for all your accounts
        </h2>
        <p className="mt-2 break-words text-[12px] leading-5 text-[#687080]">
          {email} is linked to {accountCount || roles.length} Swoodle accounts.
          Your new password will work for all of them:
        </p>
        <div className="mt-2 flex flex-wrap gap-2">
          {roleBadges.map(({ label, className, icon, iconFilter }) => (
            <span
              key={label}
              className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-[12px] font-[500] ${className}`}
            >
              {icon && (
                <img
                  src={icon}
                  alt=""
                  aria-hidden="true"
                  className="h-3 w-3 shrink-0 object-contain"
                  style={{ filter: iconFilter }}
                />
              )}
              {label}
            </span>
          ))}
        </div>
        <div className="mt-3 flex gap-3 rounded-[12px] bg-[#F3F5F7] px-3 py-3 text-[12px] leading-[1.5] text-[#687080]">
          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#687080] font-[600]">
            i
          </span>
          <p>
            After the reset, use your new password to log in to the app and the
            web portal.
          </p>
        </div>
        <div className="mt-4 flex justify-end gap-2 max-sm:flex-col">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="h-[40px] flex-1 rounded-[9px] border border-[#E1E5EA] px-5 text-[12px] font-[500] text-[#303030] disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onContinue}
            disabled={loading}
            className="h-[40px] flex-1 rounded-[9px] bg-[#00ADEF] px-5 text-[12px] font-[600] text-white disabled:cursor-not-allowed disabled:opacity-60"
          >
            {loading ? "Resetting..." : "Continue to reset"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MultipleAccountsModal;
